import styled from 'styled-components';
import { Radio } from 'antd';
import breakpoints from 'base/constants/breakpoints';

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 423px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  z-index: 1000;

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: calc(100vw - 32px); // 16px space on each side
    max-width: 95vw;
    padding: 16px;
  }
`;

export const SuccessModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 461px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: left;
  z-index: 1000;

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: calc(100vw - 32px);
    max-width: 95vw;
    padding: 16px;
  }
`;

export const SuccessHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SuccessIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #14803c;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const SuccessTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
`;

export const SuccessMessage = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin: 0 0 24px 0;
  padding-left: 35px;
`;

export const CloseButton = styled.button`
  float: right;
  padding: 8px 16px;
  border: 1px solid #c2c7d0;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #f5f5f5;
  }

  @media screen and (${breakpoints.maxWidth.xs}) {
    float: none;
    display: block;
    width: 100%;
    margin: 24px 0 0 0;
    text-align: center;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 20px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 16px;
`;

export const Title = styled.h2`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin: 0;
`;

export const ChangeEmailTitle = styled(Title)`
  text-align: left;
  padding: 0;
  margin-bottom: 8px;
`;

export const Body = styled.div`
  font-size: 14px;
  line-height: 1.5;
  padding-left: 40px;
`;

export const BodyLeft = styled(Body)`
  text-align: left;
  padding: 0;
  margin-bottom: 8px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;
  flex-direction: row;

  @media screen and (${breakpoints.maxWidth.xs}) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const MainButtonContainer = styled(ButtonContainer)`
  flex-direction: row-reverse;

  @media screen and (${breakpoints.maxWidth.xs}) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const LeftButtonGroup = styled.div`
  display: flex;
  gap: 8px;

  @media screen and (${breakpoints.maxWidth.xs}) {
    order: 3;
    width: 100%;
  }
`;

export const RightButtonGroup = styled.div`
  display: flex;
  gap: 8px;

  @media screen and (${breakpoints.maxWidth.xs}) {
    flex-direction: column;
    width: 100%;
    order: 1;
  }
`;
export const Button = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

export const DontShareButton = styled(Button)`
  color: #cf3537;
  background: none;
  padding: 0;

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: 100%;
    padding: 10px 16px;
    text-align: center;
  }
`;

export const ChangeEmailButton = styled(Button)`
  color: #14151c;
  border: 1px solid #c2c7d0;
  background: #fff;
  width: auto;

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: 100%;
    order: 2;
    background: #f3f4f6;
    border: none;
  }
`;

export const AddEmailButton = styled(Button)`
  color: #fff;
  border: 1px solid #c2c7d0;
  background: #14803c;
  width: auto;

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: 100%;
    order: 2;
    background: #f3f4f6;
    border: none;
  }
`;

export const ChangeEmailButtonContainer = styled(ButtonContainer)`
  @media screen and (${breakpoints.maxWidth.xs}) {
    flex-direction: row;
    gap: 8px;

    button {
      width: 50%;
    }
  }
`;
export const ShareButton = styled(Button)`
  background: #14803c;
  color: white;
  width: auto;

  &:disabled {
    background: #c2c7d0;
    cursor: not-allowed;
  }

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: 100%;
    order: 1;
  }
`;

export const ErrorMessage = styled.p`
  color: #cf3537;
  font-size: 12px;
  margin: 5px 0;
  text-align: left;
`;

export const StyledInput = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid ${(props) => (props.hasError ? '#CF3537' : '#C2C7D0')};
  border-radius: 4px;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.hasError ? '#CF3537' : '#14803C')};
  }
`;

export const ReasonModalContainer = styled(ModalContainer)`
  width: 375px;
  height: 273px;
  padding: 24px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (${breakpoints.maxWidth.xs}) {
    width: calc(100vw - 32px);
    height: auto;
    min-height: 273px;
  }
`;
export const ReasonTitle = styled(Title)`
  font-size: 16px;
  color: #14151c;
  margin-bottom: 12px;
  padding: 0;
  font-style: normal;
  font-weight: 600;
  text-align: center;
`;

export const StyledRadioGroup = styled(Radio.Group)`
  width: 100%;

  .ant-radio-wrapper {
    margin-bottom: 12px;
    font-size: 14px;
    color: #14151c;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ant-radio {
    top: 0;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #14803c;
    &::after {
      background-color: #14803c;
    }
  }
`;

export const ReasonButtonContainer = styled(ButtonContainer)`
  margin-top: 0;
  justify-content: space-between;
  gap: 16px;

  @media screen and (${breakpoints.maxWidth.xs}) {
    flex-direction: row;
    gap: 8px; // Reduce gap for mobile
  }
`;

export const ReasonButton = styled(Button)`
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  background: var(--Neutral-neutral-10, #f3f4f6);

  &:first-child {
    color: #14151c;
    background: white;
    border: 1px solid #c2c7d0;
    width: 100%;

    @media screen and (${breakpoints.maxWidth.xs}) {
      width: 50%;
    }
  }

  &:last-child {
    background: #14803c;
    width: 100%;
    color: white;

    @media screen and (${breakpoints.maxWidth.xs}) {
      width: 50%;
    }

    &:disabled {
      background: #e5e7eb;
      color: #9ca3af;
      cursor: not-allowed;
    }
  }
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const TickIcon = styled.span<{ isError?: boolean }>`
  position: absolute;
  right: 12px;
  top: 40%;
  transform: translateY(-50%);
  color: ${(props) => (props.isError ? '#ff4d4f' : '#52c41a')}; // Red for error, Green for success
  display: flex;
  align-items: center;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #dfe2e7;
  margin: 0 -24px 12px -24px;
`;
